import validator from 'validator'
import checkUtente from '../services/checkUtente';
import getPresenze from '../services/getPresenze';
import getChiusura from '../services/getChiusura';
import getLezioni from '../services/getLezioni';
import getStudenti from '../services/getStudenti';
import { toast, Bounce } from 'react-toastify';
import ReactGA from 'react-ga4';

import moment from 'moment';
import Cookies from 'universal-cookie';
import translateString from './Locales';

let t = translateString;

export default class Utils {

static async filterLessonsWithoutRegisters(lessons){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    var studenti = await getStudenti(username, token);

    var compareData = moment();
    var compareDataBegin = moment();

    compareDataBegin = compareDataBegin.add(-8, 'days');
    compareDataBegin.hour(23);
    compareDataBegin.minutes(59);

    var retList = [];
    for (var l of lessons){
        var data = moment(l.data, "yyyy-MM-DD HH:mm:ss");

        if (data < compareDataBegin) 
          continue;
        if (data > compareData) 
          continue;

        var corsi = [l.id_corso];
        for (var c of l.altri_corsi.split(';'))
            corsi.push(c);

        var studentiCorso = studenti.filter(s => {
            var sCorsi = s.corsi.split(';');
            return Utils.isComponentArrayMatch(corsi, sCorsi);
        })

        var presenze = await getPresenze(username, token, l.id);
        // controlla se la presenza è stata registrata per tutti gli studenti
        if (presenze.length >= studentiCorso.length) 
            continue;

        retList.push(l);
    }

    return retList;
}

static setAnalyticsPage(page) {

    let t = translateString;
    ReactGA.send({ hitType: 'pageview', page: '/' + page + ' - ' + t('language_string') });
}

static isComponentArrayMatch(arr1, arr2){
    for (var e1 of arr1){
        if (e1 == '') continue;
        for (var e2 of arr2){
            if (e2 == '') continue;
            if (e1 == e2)
                return true;
        }
    }
    return false;
}

static getMonthName(month){
    if (month == 1) return t('gennaio');
    if (month == 2) return t('febbraio');
    if (month == 3) return t('marzo');
    if (month == 4) return t('aprile');
    if (month == 5) return t('maggio');
    if (month == 6) return t('giugno');
    if (month == 7) return t('luglio');
    if (month == 8) return t('agosto');
    if (month == 9) return t('settembre');
    if (month == 10) return t('ottobre');
    if (month == 11) return t('novembre');
    if (month == 12) return t('dicembre');
  }

  static unescapeString(str) {
    if (!str) return '';

    var string = str;

    string = string.replace(/\\u00e0/g, 'à');
    string = string.replace(/\\u00e8/g, 'è');
    string = string.replace(/\\u00f2/g, 'ò');
    string = string.replace(/\\u00ec/g, 'ì');
    string = string.replace(/\\u00f9/g, 'ù');
    string = string.replace(/\\u00e9/g, 'é');
    string = string.replace(/\\u00e1/g, 'á');
    string = string.replace(/\\u00ed/g, 'í');
    string = string.replace(/\\u00f3/g, 'ó');
    string = string.replace(/\\u00fa/g, 'ú');
    string = string.replace(/\0/g, '');
    string = string.replace(/\\n/g, '');
    string = string.replace(/\\r/g, '');
    string = string.replace(/\\b/g, '');
    string = string.replace(/\\t/g, '');
    string = string.replace(/\\z/g, '');
    string = string.replace(/\\/g, '');

    return decodeURIComponent(string);
}

static generateUserToken() {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < 20; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
   return result;
}

static checkRegisterWarningToDisplay(){

    const cookies = new Cookies();
    const lastRegisterWarningDate = cookies.get('lastRegisterWarningDate', { path: '/' });
    if (lastRegisterWarningDate == undefined || lastRegisterWarningDate == '') return true;
    var dataLast = moment(lastRegisterWarningDate, "yyyy-MM-DD HH:mm:ss");
    var dataNow = moment();
    var diff = dataNow.diff(dataLast, 'seconds');

    // differenza di 6 ore
    if (diff > 60 * 60 * 6){
        return true;
    }
    else {
      //alert ('La differenza è di ' + diff + ' secondi');
      return false;
    }
}

static async checkLessonsForDay(day){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    let lezioni = await getLezioni(username, token);

    var lezioniOutput = '';

    lezioni.forEach(l => {

        var dataLezione = moment(l.data, "yyyy-MM-DD HH:mm:ss");
        var dataChiusura = moment(day, "DD-MM-yyyy");
        if (dataLezione.year() == dataChiusura.year())
            if (dataLezione.month() == dataChiusura.month())
                if (dataLezione.date() == dataChiusura.date()){
                    lezioniOutput += l.data + ' ' + l.str_corso + ' ' + l.cognome_ins + '\n';
                }
    });

    return lezioniOutput;
}

static getTextColorFromBackground(backgroundColor) {
    var color = (backgroundColor.charAt(0) === '#') ? backgroundColor.substring(1, 7) : backgroundColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 150) ? '#6E6E6ECC' : '#FFFFFF';
}

static showError(text) {
    /* toast.error(text, {
        hideProgressBar: true, 
        closeOnClick: true, 
        pauseOnHover: false,
        transition: Bounce,
        closeButton: false,
        toastId: 'toast_1304_e',
    }); */
    alert(text);
}

static showSuccess(text) {
    /* toast.success(text, {
        hideProgressBar: true, 
        closeOnClick: true, 
        pauseOnHover: false,
        transition: Bounce,
        closeButton: false,
        toastId: 'toast_1304_s',
      }); */
      alert(text);
}

static showInfo(text) {
    /* toast.info(text, {
        hideProgressBar: true, 
        closeOnClick: true, 
        pauseOnHover: false,
        transition: Bounce,
        closeButton: false,
        toastId: 'toast_1304_i',
      }); */

      alert(text);
}

static lightenDarkenColor(col,amt) {
    var usePound = false;
    if ( col[0] == "#" ) {
        col = col.slice(1);
        usePound = true;
    }

    var num = parseInt(col,16);

    var r = (num >> 16) + amt;

    if ( r > 255 ) r = 255;
    else if  (r < 0) r = 0;

    var b = ((num >> 8) & 0x00FF) + amt;

    if ( b > 255 ) b = 255;
    else if  (b < 0) b = 0;

    var g = (num & 0x0000FF) + amt;

    if ( g > 255 ) g = 255;
    else if  ( g < 0 ) g = 0;

    return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
}


static async getLessonsDuringClosure(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    let chiusure = await getChiusura(username, token);
    let lezioni = await getLezioni(username, token);

    var lezioniOutput = '';

    lezioni.forEach(l => {
        chiusure.forEach(c => {
            var dataLezione = moment(l.data, "yyyy-MM-DD HH:mm:ss");
            var dataChiusura = moment(c.day, "DD-MM-yyyy");
            if (dataLezione.year() == dataChiusura.year())
                if (dataLezione.month() == dataChiusura.month())
                    if (dataLezione.date() == dataChiusura.date()){
                        let asd = 34;
                        let dfg = asd;
                        lezioniOutput += l.data + ' ' + l.str_corso + ' ' + l.cognome_ins + '\n';
                    }
        })
    });

    return lezioniOutput;
}


static updateRegisterWarningToDisplay(){
    const cookies = new Cookies();
    let startDate = moment().format('yyyy-MM-DD HH:mm:ss');
    cookies.set('lastRegisterWarningDate', startDate, { path: '/' });
}


static generatePassword(){
    var password = Math.random() * 8999999 + 1000000;
    password = parseInt(password);
    return password;
}

static checkIdsArrays(arr1, arr2){
    var found = false;
    
    arr1.forEach(e1 => {
        if (e1 == '') return;
        arr2.forEach(e2 => {
            if (e2 == '') return;
            if (e1 == e2) found = true;
        });
    });

    return found;
}

 static async generateUsername(uname, token, name, surname){

        name = name.toLowerCase().trim();
        surname = surname.toLowerCase().trim();
        name = name.replaceAll(' ', '_');
        surname = surname.replaceAll(' ', '_');
    
        var username = '';
        if (name == '') username = surname;
        else if (surname == '') username = name;
        else username = name+'.'+surname;
    
        username = username.replace(" ", ".");

        var continueVal = true;
        var count = 0;
        while (continueVal){
          if (count > 0) username = username + count;
          var result = await checkUtente(uname, token, username);
          if (result.length > 0) count++;
          else continueVal = false;
        }
        username = username.replace("\'", "");
        username = username.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        
        return username;
      }

  static validateEmail = (email) => {
    if (validator.isEmail(email)) {
      return true;
    } else {
        return false;
    }
  }

  static capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

    static escapeString (str) {
        if (!str) return '';
        
        return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
            switch (char) {
                case "\0":
                    return "\\0";
                case "\x08":
                    return "\\b";
                case "\x09":
                    return "\\t";
                case "\x1a":
                    return "\\z";
                case "\n":
                    return "\\n";
                case "\r":
                    return "\\r";
                case "\"":
                case "'":
                case "\\":
                case "%":
                    return "\\"+char; // prepends a backslash to backslash, percent,
                                      // and double/single quotes
                default:
                    return char;
            }
        });
    }
    
    static getHoursArray(){
        var arr = [];
        for (var i = 0; i < 24; i++){
            arr.push(i);
        }
        return arr;
    }

    static getMinutesArray(){
        var arr = [];
        for (var i = 0; i < 60; i+=5){
            arr.push(i);
        }
        return arr;
    }


    static roundTime (str) {
        if (str.length == 1){
            return "0"+str;
        }
        else return str;
    }

}